import Vue from "vue";
import Vuex from "vuex";
import Datatable from "./dataTables/index"
import VuexPersist from 'vuex-persist'
import AuthenticationApi from "../api/authentication_api"

const vuexPersist = new VuexPersist({
  key: 'borderex-storage',
  storage: window.localStorage
})

Vue.use(Vuex);

const defaultSnackbar = {
  show: false,
  color: 'info',
  text: '',
  direction: ['bottom', 'center'],
  timeout: 3000
}

export default new Vuex.Store({
  state: {
    barColor: "rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)",
    barImage:
      "https://demos.creative-tim.com/material-dashboard/assets/img/sidebar-1.jpg",
    drawer: null,
    loggedIn: false,
    user: {},
    snackbar: defaultSnackbar
  },
  mutations: {
    SET_BAR_IMAGE(state, payload) {
      state.barImage = payload;
    },
    SET_DRAWER(state, payload) {
      state.drawer = payload;
    },
    AUTHENTICATE(state, payload) {
      if(payload) {
        state.loggedIn = true;
        state.user = payload
      } else {
        state.loggedIn = false;
        state.user = {}
      }
    },
    LOG_OUT(state) {
        state.loggedIn = false;
        state.user = {}
    },
    SHOW_SNACKBAR: (state, payload) => {
      state.snackbar = { ...state.snackbar, ...payload}
      setTimeout(function(){ state.snackbar.show = false }, state.snackbar.timeout);
    },
    HIDE_SNACKBAR: (state) => {
      return state.snackbar.show = false
    },

  },
  actions: {
    SHOW_SNACKBAR: ({ state, commit }, payload) => {
      commit('SHOW_SNACKBAR', payload)
      setTimeout(function(){ commit('SHOW_SNACKBAR', defaultSnackbar) }, state.snackbar.timeout);
    },
    AUTHENTICATE:  async ({ commit }, {email, password}) => {
      try {
        const { data } = await AuthenticationApi.authenticate({email, password})
        commit('AUTHENTICATE', data)
      } catch (e) {
        console.error('UPDATE_BOOKING_LIST -> ', e)
        commit('AUTHENTICATE', null)
      }
    },
    LOG_OUT: ({commit}) => {
      commit('LOG_OUT')
    }
  },
  modules: {
    dataTables: Datatable
  },
  plugins: [vuexPersist.plugin],
});
